var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQuestionIco = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  fill: "#F3A900",
  rx: 24
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M24 13.334A6.674 6.674 0 0 0 17.333 20H20c0-2.205 1.795-4 4-4s4 1.795 4 4c0 1.425-.605 1.953-1.975 3.007-.509.392-1.084.834-1.634 1.384-1.75 1.748-1.731 3.472-1.724 3.61v2.666h2.666v-2.679c0-.032.031-.801.943-1.712.427-.427.91-.797 1.375-1.156 1.413-1.088 3.016-2.32 3.016-5.12A6.674 6.674 0 0 0 24 13.334M22.667 32h2.666v2.667h-2.666z"
})));
export default SvgQuestionIco;